export default class JobAdvancedSearch {
    constructor(
        public keyword?: string,
        public location?: string,
        public provider?: string,
        public excludekeyword?: string,
        public minsalary?: string,
        public maxsalary?: string,
        public maxyearofexp?: string,
        public minyearofexp?: string,
        public page?: number,
        public employmenttype?:string,
        public jobcategory?:string
    ){}
}